// @mui
import { useTheme, styled } from '@mui/material/styles';
import { Stack, AppBar, Toolbar } from '@mui/material';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// hooks
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
// components
import { NAV, HEADER } from '../../../config-global';
// ----------------------------------------------------------------------------------------------

const StyledLogo = styled('div')(({ theme }) => ({
    // width: NAV.W_DASHBOARD,
    width: NAV.W_DASHBOARD_NEW,
    height: HEADER.H_DASHBOARD_DESKTOP_NEW,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
}));
// --------------------------------------------------------------------------------------------------------

export default function DashboardParamHeader() {

    const theme = useTheme();
    const isDesktop = useResponsive('up', 'lg');
    // const isOffset = useOffSetTop(HEADER.H_DASHBOARD_DESKTOP);
    const isOffset = useOffSetTop(HEADER.H_DASHBOARD_DESKTOP_NEW);

    const renderContent = (
        <Stack direction='row' justifyContent='flex-start' alignItems='center' spacing={2}>
            {/*  <StyledLogo sx={{ height: { xs: HEADER.H_MOBILE, lg: HEADER.H_DASHBOARD_DESKTOP } }}>    */}
            <StyledLogo>
                <img src='/logo/JJ-CORE-Logowhite.png' alt='' className="JJCoreLogo" />
            </StyledLogo>

            <img src='/logo/J&J MedTech Logo.png' alt='' draggable={false} className='JnJMedTechLogo' />
        </Stack>
    );

    return (
        <AppBar
            sx={{
                boxShadow: 'none',
                // height: HEADER.H_MOBILE,
                zIndex: theme.zIndex.appBar + 1,
                padding: 0,
                ...bgBlur({
                    color: theme.palette.background.default,
                    backgroundColor: theme.palette.background.paper,
                }),
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                }),
                ...(isDesktop && {
                    width: '100%',
                    //  height: HEADER.H_DASHBOARD_DESKTOP,
                    height: HEADER.H_DASHBOARD_DESKTOP_NEW,
                    backgroundColor: theme.palette.background.paper,
                    ...(isOffset && {
                        //  height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
                    }),
                }),
            }}
        >
            <Toolbar
                sx={{
                    height: 1,
                    '@media (min-width:600px)': {
                        pl: 0
                    }
                }}
            >
                {renderContent}
            </Toolbar>
        </AppBar>
    );
}
